module.exports = __webpack_public_path__ + "media/images/sales/early/badge-point-02-9f21a1842af70f6b0cef2a7bcf8f5d43.svg";